import {NextPage} from "next";
import Layout from "../../../components/layout";
import SidebarContainer from "../../../components/@container/sidebar-container";
import IRWorkshopInstructionalLibrary from "../../../components/@vida/ir-workshop-instructional-library";
import React from "react";
import IrWorkshopInstructionalLibrarySidebar
  from "../../../components/@vida/vida-sidebar/ir-workshop-instructional-library-sidebar";

const BasicTraining: NextPage = () => (
  <Layout title="IR Workshop Instructional Library" omit={true}>
    <SidebarContainer
      sidebar={<IrWorkshopInstructionalLibrarySidebar/>}
      content={<IRWorkshopInstructionalLibrary/>
      }
    />
  </Layout>
);

export default BasicTraining;
